module.exports = __webpack_public_path__ + "img/夢莎逆時雙效洗顏霜Ⅱ.40f1b793.png";